'use client';

import ReactMarkdown from 'react-markdown';
import { useInitialize, useTheme } from '../../hooks';
import { Card, Stack } from '@mui/material';
import { Localized } from '../../types/General';
import { useState } from 'react';
import { fetchPrivacy } from '../../api/privacy/fetchPrivacyText';
import NotFound from '../../app/[locale]/(digitalHub)/not-found';
import { Column, HeadlineSmall } from '../../styles';

const PrivacyScreen = () => {
    const theme = useTheme();
    const [privacy, setPrivacy] = useState<Localized | null>(null);
    const [hasError, setHasError] = useState<boolean>(false);

    useInitialize(() => {
        fetchPrivacy()
            .then((response) => {
                setPrivacy(response.privacy);
                setHasError(response.error !== undefined);
            })
            .catch((error) => {
                console.error(error);
            });
    });

    if (hasError) return <NotFound />;
    if (!privacy) return null;

    return (
        <Stack spacing={theme.spacing(3)} pb={4}>
            <Card sx={{ px: 3, py: 1 }}>
                <Column gap={3}>
                    <HeadlineSmall color='primary'>Datenschutz</HeadlineSmall>
                    <ReactMarkdown>{privacy.de.replaceAll('\n', '  \n ')}</ReactMarkdown>
                </Column>
            </Card>
        </Stack>
    );
};

export { PrivacyScreen };
